import { dateToday } from "../date-today";

const development = {
  environment: "DEVELOPMENT",
  et3arrafLink: "https://www.et3arraf.com",
  API_URL: "https://admin-development-khattabat-server.alkhattaba.app/",
  file_center: "http://et3-uploads.s3.amazonaws.com/",
  voiceAttachmentUrl: "https://s3-eu-west-1.amazonaws.com/et3-voice/",
  imageAttachmentUrl:
    "https://s3-eu-west-1.amazonaws.com/et3-attachment-image/",
  pictureUrl: "https://s3-eu-west-1.amazonaws.com/et3-uploads/",
  selfiePictureUrl: "https://s3-eu-west-1.amazonaws.com/et3-selfie-image/",
  env: "Staging",
  date: dateToday,
  IS_UNDER_CONSTRUCTION: false,

  version: "7.3.5",

  encryptData: "ADMIN2021ET3#ET3#",
  pass: "iamAdmin#111#Trust##Me#letMEInET3#",

  apiKey: "AIzaSyBg_Z2_LcYkdGhRlFjNpQQ2Mi7jHNqw_Lk",
  authDomain: "khattaba-test.firebaseapp.com",
  projectId: "khattaba-test",
  storageBucket: "khattaba-test.appspot.com",
  messagingSenderId: "579686194285",
  appId: "1:579686194285:web:fff7fe8e82263778533364",
  firebaseVapidKey:
    "BI40LAelwROHV9hYGvV6-WDZKtKrmp7LPdBUsUptX_tcSujzBII-tqTUhwzXveJCUAexo9-KUYeV_2TdUz24jYo",
  appControlDocumentId: "admin-khattabat-testing"
};

export default development;
